import * as React from 'react';
import { Link } from "react-router-dom";
import * as classNames from "classnames";

const InternalAbsoluteLink = (route: string, label: string, icon: string, className: string, target?: string) => {
    return <Link
        className={className}
        key={`link-${label}`}
        to={`${route}`}
        target={target}
    >
        {icon ? <i className={classNames("fa", icon)} aria-hidden="true"></i> : null}
        {label}
    </Link>
};

export default InternalAbsoluteLink;